// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import useMergeProps from '../../../../hooks/useMergeProps';
import { useBoomStepContext } from '../../contexts/BoomStepContext';
import { selectBoomGlobalStakeMaxRefAmount } from '../../selectors/global/globalPrimary.selector';
import { selectBoomStepsEntity } from '../../selectors/steps/stepsPrimary.selector';
import { BoomStepStatuses } from '../../types/steps';
import BoomHistoryItemContainer from '../BoomHistoryItem/BoomHistoryItemContainer';

import BoomStepInfo from './BoomStepInfo';

const BoomHistoryItemWrapper = styled.div``;

type PropsType = {
  className?: string;
  betslipReference?: string;
};

const BoomStepInfoContainer = ({ betslipReference, className = '' }: PropsType) => {
  const { stepId, stepStatus } = useBoomStepContext();
  const selectorProps = useMemo(() => ({ stepId }), [stepId]);
  const stepInfo = useSelector((state) => selectBoomStepsEntity(state, selectorProps));
  const stakeMaxRefAmount = useSelector(selectBoomGlobalStakeMaxRefAmount);

  const selectedProps = useMemo(
    () => ({
      ...stepInfo.eligibility,
      stakeMultiplier: stepInfo.stakeMultiplier,
      stakeMaxRefAmount,
    }),
    [stepInfo, stakeMaxRefAmount],
  );

  const otherProps = useMemo(() => ({ isLocked: stepStatus === BoomStepStatuses.LOCKED }), [stepStatus]);

  const enhancedProps = useMergeProps({ selectedProps, otherProps });

  if (betslipReference) {
    return (
      <BoomHistoryItemWrapper className={className}>
        <BoomHistoryItemContainer betslipReference={betslipReference} />
      </BoomHistoryItemWrapper>
    );
  }

  if (stepId) {
    return <BoomStepInfo className={className} {...enhancedProps} />;
  }

  return null;
};

export default BoomStepInfoContainer;
